import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Topbar from "../../components/Topbar";
import Leftbar from "../../components/Leftsidebar";
import { Link } from "react-router-dom";
import Loaderspinner from "../../components/Loader";
import { Row, Col, Modal } from "react-bootstrap";
import { getResourceUserVideo, createResourceUserVideo, deleteResourceUserVideos, showToast } from "../Utils/utils";
import ReactPaginate from "react-paginate";
import SweetAlert from "react-bootstrap-sweetalert";

const UserVideos = () => {
    const { id } = useParams();

    const [showSidebar, setShowSidebar] = useState(false);
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [search, setSearch] = useState("");
    const [videoList, setVideosList] = useState([]);
    const [vidoeId, setVideoId] = useState(null);
    const [showAlert, setShowAlert] = useState(false);
    const [videoModal, setVideoModal] = useState(false)
    const [videoTitle, setVideoTitle] = useState('')
    const [videoCover, setVideoCover] = useState(null)
    const [videoFile, setVideoFile] = useState(null)

    const handleSidebar = () => {
        setShowSidebar(!showSidebar);
    };

    const handleSidebarClose = () => {
        setShowSidebar(false);
    };

    useEffect(() => {
        if (search.length == 0 || search.length >= 3) {
            fetchList();
        }
    }, [page, search]);

    const fetchList = async () => {
        try {
            setLoading(true);
            const limit = 10;
            const offset = page * limit;

            const response = await getResourceUserVideo({ resource_user_id: id, search, limit, offset });

            if (response?.status == 200) {
                setVideosList(response?.data?.rows);
                if ((response?.data?.count || 0) < limit) {
                    setTotalPages(page + 1);
                } else {
                    setTotalPages(page + 2);
                }
            } else {
                console.log("cannot fetch videos", response)
            }

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const onCoverChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setVideoCover(file)
    };
    const onFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setVideoFile(file)
    }

    const isValidUrl = (url) => {
        try {
            new URL(url);
            return true;
        } catch {
            return false;
        }
    };

    const isHttpsUrl = (url) => {
        try {
            const parsed = new URL(url);
            return parsed.protocol === "https:";
        } catch {
            return false;
        }
    };

    const isYoutubeUrl = (url) => {
        return /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\//.test(url);
    };

    const isVideoFileUrl = (url) => {
        return /\.(mp4|webm|ogg|m3u8)$/i.test(url);
    };

    const handleCreateVideo = async (e) => {
        e.preventDefault();
        if (!(videoFile instanceof File)) {

            if (!isValidUrl(videoFile)) {
                showToast("Please enter a valid URL", "error");
                return;
            }
            if (!isHttpsUrl(videoFile)) {
                showToast("Only secure HTTPS video URLs are allowed", "error");
                return;
            }
            if (!isYoutubeUrl(videoFile) && !isVideoFileUrl(videoFile)) {
                showToast(
                    "Only YouTube links or direct video URLs are allowed",
                    "error"
                );
                return;
            }
        }
        try {
            setLoading(true)
            const formData = new FormData();
            formData.append("resource_user_id", id);
            formData.append("title", videoTitle);
            formData.append("cover", videoCover);
            formData.append(videoFile instanceof File ? "file" : "video_url", videoFile);

            const response = await createResourceUserVideo({ formData });
            if (response.status == 200) {
                showToast("Video added successfully", "success")
                fetchList()
                handleClose()
            } else {
                showToast(response?.data?.message || response?.data, "error")
            }

        } catch (error) {
            console.log(error, "error...");
            setLoading(false)
            showToast(error.message, "error")
        } finally {
            setLoading(false)
        }
    };

    const handleClose = () => {
        setVideoModal(false);

        setVideoTitle("");
        setVideoCover(null);
        setVideoFile(null);
    };

    const handleDelete = async () => {
        var res = await deleteResourceUserVideos(vidoeId)
        if (res.status == 200) {
            showToast("Deleted successfully", "success");
            fetchList();
        }
        setShowAlert(false);
    };

    return (
        <>
            <div class="g-sidenav-show  bg-gray-100 min-vh-100">
                <div id="wrapper">
                    <Leftbar showSidebar={showSidebar}
                        handleSidebarClose={handleSidebarClose} />
                    <main className="main-content border-radius-lg">
                        <Topbar handleSidebar={handleSidebar} />
                        <div>
                            <div className="header header-bg pb-6">
                                <div className="container-fluid">
                                    <div className="header-body">
                                        <div className="row align-items-center py-4">
                                            <div className="col-lg-6 col-7">
                                                <nav
                                                    aria-label="breadcrumb"
                                                    className="d-none d-md-inline-block ml-md-4"
                                                >
                                                    <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                                                        <li className="breadcrumb-item">
                                                            <Link to="/dashboard">
                                                                <i className="fas fa-home" />
                                                            </Link>
                                                        </li>
                                                        <li className="breadcrumb-item">
                                                            <Link to="/resources"><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Resources</span></Link>
                                                        </li>
                                                        <li className="breadcrumb-item">
                                                            <Link to=""><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Manage Resource</span></Link>
                                                        </li>
                                                    </ol>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="container-fluid mt--6">
                                <div className="row">
                                    <div className="col">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="d-flex align-items-center justify-content-end mb-3">
                                                    <input
                                                        type="text"
                                                        className="search-input mx-2"
                                                        placeholder="Search"
                                                        value={search}
                                                        onChange={(e) => setSearch(e.target.value)}
                                                    />
                                                    <button className="export-btn" onClick={() => setVideoModal(true)}> Add Video </button>
                                                </div>
                                                {loading ? <Loaderspinner /> :
                                                    <div className="row">
                                                        <div className="col">
                                                            <div className="table-responsive">
                                                                <table className="table align-items-center table-flush">
                                                                    <thead className="thead-light">
                                                                        <tr>
                                                                            <th>Sr.No</th>
                                                                            <th>Title</th>
                                                                            <th>Video Url</th>
                                                                            <th>Cover</th>
                                                                            <th>Views</th>
                                                                            <th>Actions</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {videoList?.length > 0 ? (
                                                                            videoList.map((video, index) => (
                                                                                <tr key={index}>
                                                                                    <td>{index + 1}</td>
                                                                                    <td style={{ width: "130px" }}>{video?.title}</td>
                                                                                    <td>
                                                                                        <a
                                                                                            className="truncate-text"
                                                                                            href={video?.video_url}
                                                                                            target="_blank"
                                                                                            rel="noopener noreferrer"
                                                                                            style={{ fontSize: "12px" }}
                                                                                        // className="btn btn-sm btn-outline-primary"
                                                                                        >
                                                                                            {video.video_url}
                                                                                        </a>
                                                                                    </td>
                                                                                    <td style={{ width: "120px" }}>{video?.cover_url ? 'Yes' : 'No'}</td>
                                                                                    <td>
                                                                                        <button className="viewproject-btn pull-right" style={{ width: "fit-content" }} >
                                                                                            {video?.connect_count || 0}
                                                                                        </button>
                                                                                    </td>
                                                                                    <td style={{ width: "140px" }}>
                                                                                        <button className="viewproject-btn pull-right mb-1" onClick={() => {
                                                                                            setVideoId(video?.id)
                                                                                            setShowAlert(true)
                                                                                        }} >
                                                                                            <span className="text-white">Delete</span>
                                                                                        </button>
                                                                                    </td>
                                                                                </tr>
                                                                            ))) :
                                                                            <tr>
                                                                                <td colSpan="10" className="text-center"><b>No records found</b></td>
                                                                            </tr>
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                <Row>
                                                    <Col xs={12}>
                                                        <div className='paginate-css'>
                                                            <ReactPaginate
                                                                previousLabel="<"
                                                                nextLabel=">"
                                                                breakLabel="..."
                                                                pageCount={totalPages}
                                                                marginPagesDisplayed={1}
                                                                pageRangeDisplayed={2}
                                                                onPageChange={({ selected }) => setPage(selected)}
                                                                containerClassName="pagination"
                                                                activeClassName="active"
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
            <Modal
                show={videoModal}
                onHide={handleClose}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Video</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="form-group">
                        <label>Title</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter video title"
                            value={videoTitle}
                            onChange={(e) => setVideoTitle(e.target.value)}
                        />
                    </div>
                    <div className="form-group mt-3">
                        <label>Cover Image</label>
                        <div className="d-flex gap-4">
                            <label className="btn btn-outline-primary mb-0" style={{ height: "36px" }}>
                                Browse
                                <input hidden type="file" accept="image/*" onChange={onCoverChange} />
                            </label>
                            {videoCover && (
                                <>
                                    <div className="mt-2">
                                        {videoCover?.name}
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="form-group mt-3">
                            <label>Video File</label>
                            <div className="d-flex gap-4">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Paste video URL here or Upload file"
                                    value={videoFile instanceof File ? videoFile.name : videoFile}
                                    onChange={(e) => setVideoFile(e.target.value)}
                                />

                                <label className="btn btn-outline-primary mb-0">
                                    Browse
                                    <input
                                        type="file"
                                        accept="video/*"
                                        hidden
                                        onChange={onFileChange}
                                    />
                                </label>
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <button
                        className="btn btn-outline-secondary"
                        onClick={handleClose}
                    >
                        Cancel
                    </button>

                    <button
                        className="btn primary-action-btn"
                        disabled={!videoTitle.trim() && !videoFile}
                        onClick={handleCreateVideo}
                    >
                        Save
                    </button>
                </Modal.Footer>
            </Modal >
            {showAlert && (
                <SweetAlert
                    warning
                    showCancel
                    confirmBtnText="Yes, delete it!"
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="secondary"
                    title="Are you sure?"
                    onConfirm={handleDelete}
                    onCancel={() => setShowAlert(false)}
                    focusCancelBtn
                >
                    This action cannot be undone.
                </SweetAlert>
            )}
        </>
    );
};

export default UserVideos;
